export default "__VITE_ASSET__CnhMPeWP__"